import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
 
export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            redirect:"/homePage"          
        },
        {
            path: "/home",
            name: 'home',
            // component: home
            component: resolve => require(['@/pages/home/home'], resolve)
        },
        // 搜索资讯
        {
            path: '/TotalSearch',
            name: 'TotalSearch',
            // component: TotalSearch
            component: resolve => require(['@/pages/totalSearch/TotalSearch'], resolve)
        },
        // 查询专区
        {
            path: '/SearchBlock',
            name: 'SearchBlock',
            // component: SearchBlock
            component: resolve => require(['@/pages/searchBlock/SearchBlock'], resolve)
        },
        // 行业动态
        {
            path: '/IndustryDynamic',
            name: 'IndustryDynamic',
            // component: IndustryDynamic
            component: resolve => require(['@/pages/industryDynamic/IndustryDynamic'], resolve)
        },
        // 协会工作
        {
            path: '/AssociationWork',
            name: 'AssociationWork',
            // component: AssociationWork
            component: resolve => require(['@/pages/associationWork/AssociationWork'], resolve)
        },
        //会员天地
        {
            path: '/MemberClub',
            name: 'MemberClub',
            // component: MemberClub
            component: resolve => require(['@/pages/memberClub/MemberClub'], resolve)
        },
        //人才建设
        {
            path: '/TalentDevelop',
            name: 'TalentDevelop',
            // component: TalentDevelop
            component: resolve => require(['@/pages/talentDevelop/TalentDevelop'], resolve)
        },
        // 优秀成果
        {
            path: '/ExcellentAchievements',
            name: 'ExcellentAchievements',
            // component: ExcellentAchievements
            component: resolve => require(['@/pages/excellentAchievements/ExcellentAchievements'], resolve)
        },
        //行业自律
        {
            path: '/IndustrySelfControlled',
            name: 'IndustrySelfControlled',
            // component: IndustrySelfControlled
            component: resolve => require(['@/pages/industrySelfControlled/IndustrySelfControlled'], resolve)
        },
        //政策法规
        {
            path: '/PoliciesRegulations',
            name: 'PoliciesRegulations',
            // component: PoliciesRegulations
            component: resolve => require(['@/pages/policiesRegulations/PoliciesRegulations'], resolve)
        },
        //党建园地
        {
            path: '/PartyBuildingGarden',
            name: 'PartyBuildingGarden',
            // component: PartyBuildingGarden
            component: resolve => require(['@/pages/partyBuildingGarden/PartyBuildingGarden'], resolve)
        },
        //文档详情
        {
            path: '/DocInfo',
            name: 'DocInfo',
            // component: DocInfo
            component: resolve => require(['@/pages/docInfo/DocInfo'], resolve)
        },
        // 协会刊物-列表
        {
            path: '/PublicationList',
            name: 'PublicationList',
            // component: PublicationList
            component: resolve => require(['@/pages/publicationList/PublicationList'], resolve)
        },
        // 协会刊物-详情内容
        {
            path: '/publication',
            name: 'publication',
            // component: publication
            component: resolve => require(['@/pages/publication/publication'], resolve)
        },
        // 行业精英-详情内容
        {
            path: '/PersonageInfo',
            name: 'PersonageInfo',
            // component: PersonageInfo
            component: resolve => require(['@/pages/personageInfo/PersonageInfo'], resolve)
        },
        // 关于我们-协会简介等详情页面
        {
            path: '/AboutUs',
            name: 'AboutUs',
            // component: AboutUs
            component: resolve => require(['@/pages/aboutUs/AboutUs'], resolve)
        },
 
        /** 移动端页面 */
        {
            path: '/Xhome',
            name: 'Xhome',
            // component: Xhome
            component: resolve => require(['@/pages/xhome/Xhome'], resolve)
        },
        {
            path: '/HomePage',
            name: 'HomePage',
            // component: HomePage
            component: resolve => require(['@/pages/homePage/HomePage'], resolve)
        },
 
        //优秀成果
        {
            path: '/XPrimaryTow',
            name: 'XPrimaryTow',
            // component: XPrimaryTow
            component: resolve => require(['@/pages/xPrimaryTow/XPrimaryTow'], resolve)
        },       
        // 行业动态
        {
            path: '/XPrimarythree',
            name: 'XPrimarythree',
            // component: XPrimarythree
            component: resolve => require(['@/pages/xPrimarythree/xPrimarythree'], resolve)
        },
        // 协会工作
        {
            path: '/XPrimaryFour',
            name: 'XPrimaryFour',
            // component: XPrimaryFour
            component: resolve => require(['@/pages/xPrimaryFour/XPrimaryFour'], resolve)
        }, 
        // 行业自律
        {
            path: '/XPrimaryFive',
            name: 'XPrimaryFive',
            // component: XPrimaryFive
            component: resolve => require(['@/pages/xPrimaryFive/XPrimaryFive'], resolve)
        },
        // 人才建设
        {
            path: '/XPrimarySix',
            name: 'XPrimarySix',
            // component: XPrimarySix
            component: resolve => require(['@/pages/xPrimarySix/XPrimarySix'], resolve)
        },
        // 政策法规
        {
            path: '/XPrimarySeven',
            name: 'XPrimarySeven',
            // component: XPrimarySeven
            component: resolve => require(['@/pages/xPrimarySeven/XPrimarySeven'], resolve)
        },       
        // 党建园地
        {
            path: '/XPrimaryEight',
            name: 'XPrimaryEight',
            // component: XPrimaryEight
            component: resolve => require(['@/pages/xPrimaryEight/XPrimaryEight'], resolve)
        },
        // 党建园地
        {
            path: '/XPrimaryNine',
            name: 'XPrimaryNine',
            // component: XPrimaryNine
            component: resolve => require(['@/pages/xPrimaryNine/XPrimaryNine'], resolve)
        },     
        //移动 详情
        {
            path: '/XInfo1',
            name: ' XInfo1',
            // component:  XInfo1
            component: resolve => require(['@/pages/xInfo1/xInfo1'], resolve)
        },
        //移动 人物详情
        {
            path: '/XPersonInfo',
            name: 'XPersonInfo',
            // component: XPersonInfo
            component: resolve => require(['@/pages/xPersonInfo/XPersonInfo'], resolve)
        },
        //移动 底部栏-详情
        {
            path: '/XAbout',
            name: 'XAbout',
            // component:  XAbout
            component: resolve => require(['@/pages/xAbout/XAbout'], resolve)
        },
        //移动 搜索页面
        {
            path: '/XSearch',
            name: 'XSearch',
            // component:  XSearch
            component: resolve => require(['@/pages/xSearch/XSearch'], resolve)
        },               
        //移动 查询专区
        {
            path: '/XInquiry',
            name: 'XInquiry',
            // component:  XInquiry
            component: resolve => require(['@/pages/xInquiry/XInquiry'], resolve)
        }, 
        //移动 详情跳转页
        {
            path: '/DetailsPage',
            name: 'DetailsPage',
            // component:  XInquiry
            component: resolve => require(['@/pages/detailsPage/DetailsPage'], resolve)
        },      
        //移动 详情跳转页（人物）
        {
            path: '/DetailsTowPage',
            name: 'DetailsTowPage',
            // component:  XInquiry
            component: resolve => require(['@/pages/detailsTowPage/DetailsTowPage'], resolve)
        }, 
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})
